module.exports = __webpack_public_path__ + "img/paper.c37224c4.png";